
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-eddf03b0&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CopyrightIndex.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./CopyrightIndex.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-eddf03b0!../../node_modules/vue-loader/lib/selector?type=template&index=0!./CopyrightIndex.vue"),
  /* scopeId */
  "data-v-eddf03b0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/CopyrightIndex.vue
// module id = 332
// module chunks = 0